module.exports = __webpack_public_path__ + "static/media/FeelsLikeHome.df64fc7d.ico";